import { Grid } from "@mantine/core";
import { memo, useEffect } from "react";
import Credits from "./credits";
import Agreements from "./Agreements";
import {
  useGetSignedAgreementsLazyQuery,
  useGetCreditAllotmentManyLazyQuery,
} from "src/generated/graphql";
import { useParams } from "react-router-dom";

const Account = () => {
  const { clientId } = useParams<{ clientId: string }>();

  const [getSignedAgreements, { data: agreementData }] =
    useGetSignedAgreementsLazyQuery({
      variables: {
        clientId: clientId || "",
      },
      fetchPolicy: "network-only",
    });

  const [getCredits, { data: creditsData }] =
    useGetCreditAllotmentManyLazyQuery({
      variables: {
        clientId: clientId || "",
      },
      fetchPolicy: "no-cache",
    });

  useEffect(() => {
    getCredits();
    getSignedAgreements();
  }, []);

  return (
    <Grid>
      <Grid.Col md={6}>
        <Credits creditsData={creditsData?.creditAllotmentMany || []} />
      </Grid.Col>

      <Grid.Col md={6}>
        <Agreements
          agreementData={agreementData?.signedAgreementMany || []}
          onRefetch={() => getSignedAgreements()}
        />
      </Grid.Col>
    </Grid>
  );
};

export default memo(Account);
